import React, { useContext, useState } from 'react';
import { BinConstraintContext } from '../../../../../../../context/BinConstraintContext';
import { useToast } from '../../../../../../../providers/ToastProvider';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../types/translation/Translator';
import { AlertModal } from '../../../../../../components/Modal';
import { Button, ButtonVariant } from '../../../../../../components/Button';
import { BinConstraint } from '../../../../../../../types/bin_constraints/binConstraint';
import { BinConstraintInput } from '../../../../../../../types/bin_constraints/binConstraint.input';
import { BinConstraintRequest } from '../../../../../../../requests/binConstraint.request';
import { useRequest } from '../../../../../../../requests/common/requestHook';

interface DeleteBinConstraintModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  item?: BinConstraint;
}

export default function DeleteBinConstraintModal({ open, setOpen, item }: DeleteBinConstraintModalProps) {
  const { showToast } = useToast();

  const { binConstraints, setBinConstraints } = useContext(BinConstraintContext);

  const [input, setInput] = useState<BinConstraintInput>(new BinConstraintInput(item));

  const [remove, { loading }] = useRequest(BinConstraintRequest.remove);

  const handleRemove = async () => {
    const result = await remove({ data: [input.forUpdate()] });
    if (!result) return;

    const constraint = result[0];
    binConstraints.delete(constraint.id);
    setBinConstraints(new Map(binConstraints));
    setOpen(false);
  };

  return (
    <AlertModal open={open} setOpen={setOpen} title={t(TranslationKey.binConstraintDelete).singular.upper}>
      <div className='body-light grid gap-4'>
        <p className='py-2'>{t(TranslationKey.binConstraintDeleteTitle).singular.upper}</p>

        <div className='flex items-center justify-end gap-2'>
          <Button
            text={t(TranslationKey.cancel).singular.upper}
            variant={ButtonVariant.link}
            onClick={() => setOpen(false)}
            disabled={loading}
          />
          <Button
            text={t(TranslationKey.delete).singular.upper}
            variant={ButtonVariant.danger}
            onClick={() => handleRemove()}
            loading={loading}
          />
        </div>
      </div>
    </AlertModal>
  );
}
